import { Pipe } from '@angular/core';
var StripTagsPipe = (function () {
    function StripTagsPipe() {
    }
    StripTagsPipe.prototype.transform = function (text) {
        var allowedTags = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            allowedTags[_i - 1] = arguments[_i];
        }
        return allowedTags.length > 0
            ? text.replace(new RegExp("<(?!/?(" + allowedTags.join('|') + ")s*/?)[^>]+>", 'g'), '')
            : text.replace(/<(?:.|\s)*?>/g, '');
    };
    return StripTagsPipe;
}());
export { StripTagsPipe };
StripTagsPipe.decorators = [
    { type: Pipe, args: [{ name: 'stripTags' },] },
];
/** @nocollapse */
StripTagsPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=strip-tags.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/strip-tags.js
// module id = 268
// module chunks = 4